import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  Paper,
  Typography,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import {
  GetTestLib,
  SaveTestLib,
  UpdateTestLib,
} from "../../../../services/TestLibService";
import CommonLoader from "../../../common/CommonLoader";

const AddEditTestLib = () => {
  const { testCode: testCodeParam } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(testCodeParam);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [testCode, setTestCode] = useState("");
  const [reportCode, setReportCode] = useState("");
  const [testCategory, setTestCategory] = useState("");
  const [glCode, setGlCode] = useState("");
  const [parameter, setParameter] = useState("");
  const [formulaId, setFormulaId] = useState("");
  const [specialTest, setSpecialTest] = useState(false);
  const [dateCreated, setDateCreated] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [methodCode, setMethodCode] = useState("");
  const [departmentCode, setDepartmentCode] = useState("");
  const [testUnits, setTestUnits] = useState("");
  const [testUnits2, setTestUnits2] = useState("");
  const [testUnits3, setTestUnits3] = useState("");
  const [holdTime, setHoldTime] = useState("");
  const [analyst, setAnalyst] = useState("");
  const [detectLimit, setDetectLimit] = useState("");
  const [controlConc, setControlConc] = useState("");
  const [minControlLimit, setMinControlLimit] = useState("");
  const [maxControlLimit, setMaxControlLimit] = useState("");
  const [costOfAnalysis, setCostOfAnalysis] = useState("");
  const [laboratoryCost, setLaboratoryCost] = useState("");
  const [sortIndex, setSortIndex] = useState("");
  const [casNumber, setCasNumber] = useState("");
  const [discountCode, setDiscountCode] = useState("");
  const [applyDiscount, setApplyDiscount] = useState(false);
  const [attachment, setAttachment] = useState(false);
  const [statement, setStatement] = useState(false);
  const [qcStatement, setQcStatement] = useState(false);
  const [flag1, setFlag1] = useState("");
  const [flag2, setFlag2] = useState("");
  const [comments, setComments] = useState("");
  const [testType, setTestType] = useState("");
  const [sigfigs, setSigfigs] = useState("");
  const [defaultConc, setDefaultConc] = useState("");
  const [estimatedTime, setEstimatedTime] = useState("");
  const [machineId, setMachineId] = useState("");
  const [prepRequired, setPrepRequired] = useState(false);
  const [sampleBottleName, setSampleBottleName] = useState("");
  const [bottleqty, setBottleqty] = useState("");
  const [assignproc, setAssignproc] = useState("");
  const [active, setActive] = useState(true);
  const [sopfile, setSopfile] = useState("");
  const [assignqc, setAssignqc] = useState(false);
  const [recordid, setRecordid] = useState(0);
  const [minimumPrice, setMinimumPrice] = useState("");
  const [bottlePreservatives, setBottlePreservatives] = useState("");
  const [prepmethod, setPrepmethod] = useState("");
  const [farmoutlabname, setFarmoutlabname] = useState("");
  const [billable, setBillable] = useState(false);
  const [analyteCode, setAnalyteCode] = useState("");
  const [analyteGroup, setAnalyteGroup] = useState("");
  const [sampleMatrix, setSampleMatrix] = useState("");
  const [mdlDate, setMdlDate] = useState("");
  const [farmOutStreetAddress, setFarmOutStreetAddress] = useState("");
  const [farmOutCity, setFarmOutCity] = useState("");
  const [farmOutState, setFarmOutState] = useState("");
  const [farmOutZip, setFarmOutZip] = useState("");
  const [testStatus, setTestStatus] = useState("");
  const [coc, setCoc] = useState("");
  const [volumeAssayed, setVolumeAssayed] = useState("");
  const [volumeSampled, setVolumeSampled] = useState("");
  const [analyteId, setAnalyteId] = useState("");
  const [idemMethodCode, setIdemMethodCode] = useState("");
  const [methodVersion, setMethodVersion] = useState("");
  const [nelacnumber, setNelacnumber] = useState("");
  const [uploadToIDEM, setUploadToIDEM] = useState(false);
  const [parameterType, setParameterType] = useState("");

  useEffect(() => {
    if (isEdit) {
      fetchTestLib();
    }
  }, [testCodeParam]);

  const fetchTestLib = async () => {
    setLoading(true);
    try {
      const response = await GetTestLib(testCodeParam.trim());
      const t = response?.results ?? response;
      if (!t) return;
      populateFields(t);
    } catch {
      NotificationManager.error("Error loading test library record");
    } finally {
      setLoading(false);
    }
  };

  const populateFields = (t) => {
    setTestCode(t.testCode || "");
    setReportCode(t.reportCode || "");
    setTestCategory(t.testCategory || "");
    setGlCode(t.glCode || "");
    setParameter(t.parameter || "");
    setFormulaId(t.formulaId || "");
    setSpecialTest(t.specialTest || false);
    setDateCreated(t.dateCreated || "");
    setCreatedBy(t.createdBy || "");
    setMethodCode(t.methodCode || "");
    setDepartmentCode(t.departmentCode || "");
    setTestUnits(t.testUnits || "");
    setTestUnits2(t.testUnits2 || "");
    setTestUnits3(t.testUnits3 || "");
    setHoldTime(t.holdTime || "");
    setAnalyst(t.analyst || "");
    setDetectLimit(t.detectLimit || "");
    setControlConc(t.controlConc || "");
    setMinControlLimit(t.minControlLimit || "");
    setMaxControlLimit(t.maxControlLimit || "");
    setCostOfAnalysis(t.costOfAnalysis || "");
    setLaboratoryCost(t.laboratoryCost || "");
    setSortIndex(t.sortIndex || "");
    setCasNumber(t.casNumber || "");
    setDiscountCode(t.discountCode || "");
    setApplyDiscount(t.applyDiscount || false);
    setAttachment(t.attachment || false);
    setStatement(t.statement || false);
    setQcStatement(t.qcStatement || false);
    setFlag1(t.flag1 || "");
    setFlag2(t.flag2 || "");
    setComments(t.comments || "");
    setTestType(t.testType || "");
    setSigfigs(t.sigfigs || "");
    setDefaultConc(t.defaultConc || "");
    setEstimatedTime(t.estimatedTime || "");
    setMachineId(t.machineId || "");
    setPrepRequired(t.prepRequired || false);
    setSampleBottleName(t.sampleBottleName || "");
    setBottleqty(t.bottleqty || "");
    setAssignproc(t.assignproc || "");
    setActive(t.active !== undefined ? t.active : true);
    setSopfile(t.sopfile || "");
    setAssignqc(t.assignqc || false);
    setRecordid(t.recordid || 0);
    setMinimumPrice(t.minimumPrice || "");
    setBottlePreservatives(t.bottlePreservatives || "");
    setPrepmethod(t.prepmethod || "");
    setFarmoutlabname(t.farmoutlabname || "");
    setBillable(t.billable || false);
    setAnalyteCode(t.analyteCode || "");
    setAnalyteGroup(t.analyteGroup || "");
    setSampleMatrix(t.sampleMatrix || "");
    setMdlDate(t.mdlDate || "");
    setFarmOutStreetAddress(t.farmOutStreetAddress || "");
    setFarmOutCity(t.farmOutCity || "");
    setFarmOutState(t.farmOutState || "");
    setFarmOutZip(t.farmOutZip || "");
    setTestStatus(t.testStatus || "");
    setCoc(t.coc || "");
    setVolumeAssayed(t.volumeAssayed || "");
    setVolumeSampled(t.volumeSampled || "");
    setAnalyteId(t.analyteId || "");
    setIdemMethodCode(t.idemMethodCode || "");
    setMethodVersion(t.methodVersion || "");
    setNelacnumber(t.nelacnumber || "");
    setUploadToIDEM(t.uploadToIDEM || false);
    setParameterType(t.parameterType || "");
  };

  const formatDate = (d) => (d ? d.split("T")[0] : "");

  const parseData = () => ({
    testCode: testCode?.toString() || null,
    reportCode: reportCode?.toString() || null,
    testCategory: testCategory?.toString() || null,
    glCode: glCode?.toString() || null,
    parameter: parameter?.toString() || null,
    formulaId: formulaId?.toString() || null,
    specialTest: Boolean(specialTest),
    dateCreated: dateCreated ? new Date(dateCreated) : null,
    createdBy: createdBy?.toString() || null,
    methodCode: methodCode?.toString() || null,
    departmentCode: departmentCode?.toString() || null,
    testUnits: testUnits?.toString() || null,
    testUnits2: testUnits2?.toString() || null,
    testUnits3: testUnits3?.toString() || null,
    holdTime: holdTime ? parseFloat(holdTime) : null,
    analyst: analyst?.toString() || null,
    detectLimit: detectLimit?.toString() || null,
    controlConc: controlConc ? parseFloat(controlConc) : null,
    minControlLimit: minControlLimit?.toString() || null,
    maxControlLimit: maxControlLimit?.toString() || null,
    costOfAnalysis: costOfAnalysis ? parseFloat(costOfAnalysis) : null,
    laboratoryCost: laboratoryCost ? parseFloat(laboratoryCost) : null,
    sortIndex: sortIndex ? parseInt(sortIndex, 10) : null,
    casNumber: casNumber?.toString() || null,
    discountCode: discountCode?.toString() || null,
    applyDiscount: Boolean(applyDiscount),
    attachment: Boolean(attachment),
    statement: Boolean(statement),
    qcStatement: Boolean(qcStatement),
    flag1: flag1?.toString() || null,
    flag2: flag2?.toString() || null,
    comments: comments?.toString() || null,
    testType: testType?.toString() || null,
    sigfigs: sigfigs ? parseInt(sigfigs, 10) : null,
    defaultConc: defaultConc?.toString() || null,
    estimatedTime: estimatedTime ? parseFloat(estimatedTime) : null,
    machineId: machineId?.toString() || null,
    prepRequired: Boolean(prepRequired),
    sampleBottleName: sampleBottleName?.toString() || null,
    bottleqty: bottleqty ? parseInt(bottleqty, 10) : null,
    assignproc: assignproc?.toString() || null,
    active: Boolean(active),
    sopfile: sopfile?.toString() || null,
    assignqc: Boolean(assignqc),
    recordid: recordid ? parseInt(recordid, 10) : null,
    minimumPrice: minimumPrice ? parseFloat(minimumPrice) : null,
    bottlePreservatives: bottlePreservatives?.toString() || null,
    prepmethod: prepmethod?.toString() || null,
    farmoutlabname: farmoutlabname?.toString() || null,
    billable: Boolean(billable),
    analyteCode: analyteCode?.toString() || null,
    analyteGroup: analyteGroup?.toString() || null,
    sampleMatrix: sampleMatrix?.toString() || null,
    mdlDate: mdlDate ? new Date(mdlDate) : null,
    farmOutStreetAddress: farmOutStreetAddress?.toString() || null,
    farmOutCity: farmOutCity?.toString() || null,
    farmOutState: farmOutState?.toString() || null,
    farmOutZip: farmOutZip?.toString() || null,
    testStatus: testStatus?.toString() || null,
    coc: coc?.toString() || null,
    volumeAssayed: volumeAssayed?.toString() || null,
    volumeSampled: volumeSampled?.toString() || null,
    analyteId: analyteId ? parseInt(analyteId, 10) : null,
    idemMethodCode: idemMethodCode?.toString() || null,
    methodVersion: methodVersion?.toString() || null,
    nelacnumber: nelacnumber?.toString() || null,
    uploadToIDEM: Boolean(uploadToIDEM),
    parameterType: parameterType ? parseInt(parameterType.toString().trim(), 10) : 0,
  });

  const handleSubmit = async () => {
    if (!testCode) {
      NotificationManager.error("Test Code is required");
      return;
    }
    setSaving(true);
    try {
      if (isEdit) {
        await UpdateTestLib(parseData());
        NotificationManager.success("Test Library updated successfully");
      } else {
        await SaveTestLib(parseData());
        NotificationManager.success("Test Library added successfully");
      }
    } catch {
      NotificationManager.error("Error saving test library");
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    if (window.opener) {
      window.close();
    } else {
      navigate("/vlp/maintenance-test-library-management");
    }
  };

  const tf = (label, value, setter, extra = {}) => (
    <TextField
      size="small"
      label={label}
      value={value}
      onChange={(e) => setter(e.target.value)}
      fullWidth
      {...extra}
    />
  );

  const cb = (label, checked, setter) => (
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          checked={Boolean(checked)}
          onChange={(e) => setter(e.target.checked)}
        />
      }
      label={label}
    />
  );

  return (
    <div className="vlp-component-container">
      <span className="title">{isEdit ? "Edit Test Library" : "Add Test Library"}</span>
      <hr />

      <Paper elevation={2} sx={{ p: 2 }}>
        <Grid container spacing={1.5}>

          {/* Row 1 */}
          <Grid item xs={2}>{tf("Test Code *", testCode, setTestCode, { disabled: isEdit })}</Grid>
          <Grid item xs={2}>{tf("Report Code", reportCode, setReportCode)}</Grid>
          <Grid item xs={2}>{tf("Test Category", testCategory, setTestCategory)}</Grid>
          <Grid item xs={2}>{tf("GL Code", glCode, setGlCode)}</Grid>
          <Grid item xs={2}>{tf("Parameter", parameter, setParameter)}</Grid>
          <Grid item xs={2}>{tf("Formula ID", formulaId, setFormulaId)}</Grid>

          {/* Row 2 */}
          <Grid item xs={2}>
            <TextField size="small" label="Date Created" type="date" fullWidth
              value={formatDate(dateCreated)}
              onChange={(e) => setDateCreated(e.target.value)}
              InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={2}>{tf("Created By", createdBy, setCreatedBy)}</Grid>
          <Grid item xs={2}>{tf("Method Code", methodCode, setMethodCode)}</Grid>
          <Grid item xs={2}>{tf("Department Code", departmentCode, setDepartmentCode)}</Grid>
          <Grid item xs={2}>{tf("Test Units", testUnits, setTestUnits)}</Grid>
          <Grid item xs={2}>{tf("Test Units 2", testUnits2, setTestUnits2)}</Grid>

          {/* Row 3 */}
          <Grid item xs={2}>{tf("Test Units 3", testUnits3, setTestUnits3)}</Grid>
          <Grid item xs={2}>{tf("Hold Time", holdTime, setHoldTime, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Analyst", analyst, setAnalyst)}</Grid>
          <Grid item xs={2}>{tf("Detect Limit", detectLimit, setDetectLimit)}</Grid>
          <Grid item xs={2}>{tf("Control Conc.", controlConc, setControlConc, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Min Control Limit", minControlLimit, setMinControlLimit)}</Grid>

          {/* Row 4 */}
          <Grid item xs={2}>{tf("Max Control Limit", maxControlLimit, setMaxControlLimit)}</Grid>
          <Grid item xs={2}>{tf("Cost Of Analysis", costOfAnalysis, setCostOfAnalysis, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Laboratory Cost", laboratoryCost, setLaboratoryCost, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Sort Index", sortIndex, setSortIndex, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("CAS Number", casNumber, setCasNumber)}</Grid>
          <Grid item xs={2}>{tf("Discount Code", discountCode, setDiscountCode)}</Grid>

          {/* Row 5 */}
          <Grid item xs={2}>{tf("Flag 1", flag1, setFlag1)}</Grid>
          <Grid item xs={2}>{tf("Flag 2", flag2, setFlag2)}</Grid>
          <Grid item xs={2}>{tf("Comments", comments, setComments)}</Grid>
          <Grid item xs={2}>{tf("Test Type", testType, setTestType)}</Grid>
          <Grid item xs={2}>{tf("Sigfigs", sigfigs, setSigfigs, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Default Conc.", defaultConc, setDefaultConc)}</Grid>

          {/* Row 6 */}
          <Grid item xs={2}>{tf("Estimated Time", estimatedTime, setEstimatedTime, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Machine ID", machineId, setMachineId)}</Grid>
          <Grid item xs={2}>{tf("Sample Bottle Name", sampleBottleName, setSampleBottleName)}</Grid>
          <Grid item xs={2}>{tf("Bottle Qty", bottleqty, setBottleqty, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Assign Proc", assignproc, setAssignproc)}</Grid>
          <Grid item xs={2}>{tf("SOP File", sopfile, setSopfile)}</Grid>

          {/* Row 7 */}
          <Grid item xs={2}>{tf("Minimum Price", minimumPrice, setMinimumPrice, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("Bottle Preservatives", bottlePreservatives, setBottlePreservatives)}</Grid>
          <Grid item xs={2}>{tf("Prep Method", prepmethod, setPrepmethod)}</Grid>
          <Grid item xs={2}>{tf("Farmout Lab Name", farmoutlabname, setFarmoutlabname)}</Grid>
          <Grid item xs={2}>{tf("Analyte Code", analyteCode, setAnalyteCode)}</Grid>
          <Grid item xs={2}>{tf("Analyte Group", analyteGroup, setAnalyteGroup)}</Grid>

          {/* Row 8 */}
          <Grid item xs={2}>{tf("Sample Matrix", sampleMatrix, setSampleMatrix)}</Grid>
          <Grid item xs={2}>
            <TextField size="small" label="MDL Date" type="date" fullWidth
              value={formatDate(mdlDate)}
              onChange={(e) => setMdlDate(e.target.value)}
              InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={2}>{tf("Farm Out Street", farmOutStreetAddress, setFarmOutStreetAddress)}</Grid>
          <Grid item xs={2}>{tf("Farm Out City", farmOutCity, setFarmOutCity)}</Grid>
          <Grid item xs={2}>{tf("Farm Out State", farmOutState, setFarmOutState)}</Grid>
          <Grid item xs={2}>{tf("Farm Out Zip", farmOutZip, setFarmOutZip)}</Grid>

          {/* Row 9 */}
          <Grid item xs={2}>{tf("Test Status", testStatus, setTestStatus)}</Grid>
          <Grid item xs={2}>{tf("COC", coc, setCoc)}</Grid>
          <Grid item xs={2}>{tf("Volume Assayed", volumeAssayed, setVolumeAssayed)}</Grid>
          <Grid item xs={2}>{tf("Volume Sampled", volumeSampled, setVolumeSampled)}</Grid>
          <Grid item xs={2}>{tf("Analyte ID", analyteId, setAnalyteId, { type: "number" })}</Grid>
          <Grid item xs={2}>{tf("IDEM Method Code", idemMethodCode, setIdemMethodCode)}</Grid>

          {/* Row 10 */}
          <Grid item xs={2}>{tf("Method Version", methodVersion, setMethodVersion)}</Grid>
          <Grid item xs={2}>{tf("NELAC Number", nelacnumber, setNelacnumber)}</Grid>
          <Grid item xs={2}>{tf("Parameter Type", parameterType, setParameterType, { type: "number" })}</Grid>

          {/* Checkboxes */}
          <Grid item xs={2}>{cb("Active", active, setActive)}</Grid>
          <Grid item xs={2}>{cb("Attachment", attachment, setAttachment)}</Grid>
          <Grid item xs={2}>{cb("Statement", statement, setStatement)}</Grid>

          <Grid item xs={2}>{cb("QC Statement", qcStatement, setQcStatement)}</Grid>
          <Grid item xs={2}>{cb("Special Test", specialTest, setSpecialTest)}</Grid>
          <Grid item xs={2}>{cb("Apply Discount", applyDiscount, setApplyDiscount)}</Grid>

          <Grid item xs={2}>{cb("Assign QC", assignqc, setAssignqc)}</Grid>
          <Grid item xs={2}>{cb("Billable", billable, setBillable)}</Grid>
          <Grid item xs={2}>{cb("Prep Required", prepRequired, setPrepRequired)}</Grid>
          <Grid item xs={2}>{cb("Upload To IDEM", uploadToIDEM, setUploadToIDEM)}</Grid>

          {/* Actions */}
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
            <Button variant="outlined" onClick={handleClose} disabled={saving}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={saving}
              >
              {saving ? "Saving..." : isEdit ? "Update" : "Save"}
            </Button>
          </Grid>

        </Grid>
      </Paper>

      <CommonLoader loading={loading || saving} />
    </div>
  );
};

export default AddEditTestLib;
